export default __webpack_public_path__ + "static/media/tooltip.b4d16d89.png";